import { MatTableDataSource } from '@angular/material/table';
import { TableConfig } from '@next/core-lib/table';

export const defaultReportTableConfig: TableConfig = {
  dataSource: new MatTableDataSource(),
  selectColumn: false,
  pagination: false,
  header: true,
  footer: false,
  disableCards: true,
  columns: [],
};
